import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { NumericInput, Radios } from '@duckma/react-ds'
import _ from 'lodash'

import { Item, PriceModel, PriceRecurrence } from '../../../data/models'

const modelChoices: { key: PriceModel; label: string }[] = [
  { key: PriceModel.FIXED, label: 'Prezzo Fisso' },
  { key: PriceModel.PERCENTAGE, label: 'Prezzo in %' },
]

const recurrenceChoices: { key: PriceRecurrence; label: string }[] = [
  { key: PriceRecurrence.ONESHOT, label: 'Investimento iniziale' },
  { key: PriceRecurrence.MONTHLY, label: 'Ogni mese' },
]

export type Pricing = Pick<Item, 'price' | 'price_model' | 'price_recurrence'>
type Props = {
  data?: Pricing
  onChange: (info: Pricing) => void
}

export const PricingSection: React.FC<Props> = ({ data, onChange }) => {
  const [values, setValues] = useState<Pricing>({
    price: 0,
    price_model: PriceModel.FIXED,
    price_recurrence: PriceRecurrence.ONESHOT,
  })

  useEffect(() => {
    onChange(values)
  }, [onChange, values])

  useEffect(() => {
    if (data) {
      setValues(_.pick(data, ['price', 'price_model', 'price_recurrence']))
    }
  }, [data])

  return (
    <FieldsContainer>
      <NumericInput
        name="prezzo"
        label={values.price_model === PriceModel.FIXED ? 'Prezzo' : '% del prezzo'}
        description={
          values.price_model === PriceModel.FIXED
            ? 'Prezzo singolo, ad esempio 50€'
            : '% da aggiungere al prezzo dei moduli precedenti, ad esempio 20%'
        }
        value={values.price}
        onChange={(price) => setValues((v) => ({ ...v, price }))}
      />
      <Radios
        choices={modelChoices}
        value={values.price_model}
        onChange={(m) => setValues((v) => ({ ...v, price_model: m as PriceModel }))}
      />
      <Radios
        choices={recurrenceChoices}
        value={values.price_recurrence}
        onChange={(r) => setValues((v) => ({ ...v, price_recurrence: r as PriceRecurrence }))}
      />
    </FieldsContainer>
  )
}

const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    margin-bottom: 20px;
  }
`
